/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

export default function LoadingState() {
	return (
		<div className="job-board__loading" role="status" aria-live="polite">
			<div className="job-board__spinner">
				<svg
					className="job-board__spinner-icon"
					width="48"
					height="48"
					viewBox="0 0 48 48"
					aria-hidden="true"
				>
					<circle
						className="job-board__spinner-circle"
						cx="24"
						cy="24"
						r="20"
						fill="none"
						strokeWidth="4"
					/>
				</svg>
			</div>
			<p className="job-board__loading-text">{ __( 'Loading…', 'ardent' ) }</p>
		</div>
	);
}